import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/ui/PageHeader';

const NotFound: React.FC = () => (
  <div className="page-inner pb-10">
    <PageHeader title="Page not found" lead="That address does not exist here. These are the main places to go:" />
    <div className="flex flex-col sm:flex-row gap-3">
      <Link to="/pricing" className="btn btn-primary">Development pricing</Link>
      <Link to="/plans" className="btn btn-outline">Hosting plans</Link>
      <Link to="/" className="btn btn-quiet">Home</Link>
    </div>
  </div>
);

export default NotFound;
